import { toast } from 'react-toastify';
const i18n = require('i18next');

/**
 * Validates the file format against allowed types.
 * @param {File} file - The file to be validated.
 * @returns {boolean} - Returns true if the file format is allowed, otherwise false.
 */
const validateFileFormat = (file) => {
  const allowedFormats = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv", "rtf", "jpg", "jpeg", "png", "gif", 'svg', 'tiff'];
  const fileExtension = file.name.split('.').pop().toLowerCase();

  if (!allowedFormats.includes(fileExtension)) {
    toast.error(i18n.t("invalidFileFormatError", { formats: allowedFormats.join(", ") }), { position: "top-center", theme: "dark" });
    return false;
  }
  return true;
};
export default validateFileFormat;